import { useTranslation } from "react-i18next";

export function NewsletterLineup({ lineup }) {
  const { t } = useTranslation();
  if (!lineup?.length) {
    return <p className="pingflo-quiet">{t("newsletterLineupTbd", "Line-up to be confirmed")}</p>;
  }
  return (
    <ol className="pingflo-lineup" aria-label={t("newsletterLineup", "Line-up")}>
      {lineup.map((player) => (
        <li key={`${player.seat}-${player.name}`} className={`is-${player.status || "pending"}`}>
          <span className="pingflo-name">{player.name}</span>
          {player.classement ? <small>{player.classement}</small> : null}
          {player.status === "in" ? (
            <span className="pingflo-lineup-ok" title={t("newsletterConfirmed", "Confirmed")}>
              ✓
            </span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}
